/* Conservative offer eligibility. No trackers, dependencies or network polling. */
(function () {
  const modal = document.querySelector('[data-pp-offer]');
  if (!modal || !modal.showModal || window.Shopify?.designMode) return;
  const key = 'pp-offer-seen-v1', intentKey = 'pp-purchase-intent';
  try {
    if (Date.now() - Number(localStorage.getItem(key) || 0) < 7 * 86400000 || sessionStorage.getItem(intentKey)) return;
  } catch (_) { return; } // Suppress when frequency limits cannot be enforced.
  let activeMs = 0, lastTick = Date.now(), lastActivity = Date.now(), stopped = false;
  const interactions = new Set(), categories = new Set();
  let productChoice = false, previousFocus;
  const purchase = '[data-add-to-cart],[data-mobile-add],[data-cart-checkout],[data-direct-upsell-skip],a[href*="/checkout"],a[href*="/cart"],[name="checkout"]';
  function blockPurchase() {
    stopped = true;
    try { sessionStorage.setItem(intentKey, '1'); } catch (_) {}
    if (modal.open) modal.close();
  }
  function activity() { lastActivity = Date.now(); }
  ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach(name => document.addEventListener(name, activity, {passive:true}));
  document.addEventListener('click', function (event) {
    if (event.target.closest(purchase)) { blockPurchase(); return; }
    const groups = [
      ['pack', '[data-pack-button]'],
      ['size', '[data-size-chip],[data-bundle-size-chip],[data-size-select],[data-bundle-size-select]'],
      ['lab', '[data-pp-tab],[data-pp-detail],[data-pp-zone]'],
      ['guide', '[data-pack-quiz-open],[data-size-guide-open]'],
      ['faq', '.faq-item summary,.faq-section summary']
    ];
    groups.forEach(([name, selector]) => {
      const target = event.target.closest(selector);
      if (!target) return;
      interactions.add(target); categories.add(name);
      if (name === 'pack' || name === 'size') productChoice = true;
    });
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.matches('[data-ajax-product-form],form[action*="/cart"]')) blockPurchase();
  }, true);
  function busy() {
    if (document.querySelector('[data-direct-checkout-upsell]:not([hidden])')) { blockPurchase(); return true; }
    return [...document.querySelectorAll('dialog[open],[role="dialog"][aria-modal="true"]')].some(el => el !== modal && el.getClientRects().length) || document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
  }
  const timer = setInterval(function () {
    const now = Date.now(), delta = Math.min(1500, now - lastTick); lastTick = now;
    if (stopped) { clearInterval(timer); return; }
    if (document.hidden || !document.hasFocus()) return;
    if (now - lastActivity < 30000) activeMs += delta;
    if (busy() || activeMs < 120000 || interactions.size < 3 || categories.size < 2 || !productChoice || now - lastActivity < 8000) return;
    // Cross-tab frequency check immediately before showing.
    try {
      if (Date.now() - Number(localStorage.getItem(key) || 0) < 7 * 86400000 || sessionStorage.getItem(intentKey)) { stopped = true; return; }
      localStorage.setItem(key, String(now));
    } catch (_) { stopped = true; return; }
    previousFocus = document.activeElement;
    modal.showModal(); stopped = true; clearInterval(timer);
  }, 1000);
  modal.querySelectorAll('[data-offer-close]').forEach(button => button.addEventListener('click', () => modal.close()));
  modal.addEventListener('close', () => previousFocus?.focus({preventScroll:true}));
})();
